import Joi from '@hapi/joi'

export const IntegrationLogReportschemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    divisionID: Joi.number().required().label("Division Name").messages({
        "any.invalid": `Division Name cannot have invalid characters`,
        "any.required": `Division Name is required`
    }),
    fieldID: Joi.number().required().label("Field Name").messages({
        "any.invalid": `Field Name cannot have invalid characters`,
        "any.required": `Field Name is required`
    }),
    attendanceTypeID: Joi.number().required(0).required().label("Attendance Type").messages({
        "any.invalid": `Select Attendance Type`,
        "any.required": `Attendance Type required`
    }),
    blockID: Joi.number().required().label("Block Name").messages({
        "any.invalid": `Block Name cannot have invalid characters`,
        "any.required": `Block Name is required`
    }),
    date: Joi.string().invalid("").label("Date"),
}

